import * as React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Container,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  useMediaQuery,
  Button,
  IconButton,
  Divider,
  ListItemIcon,
  ListItemText,
  Chip,
  Badge,
  Tooltip,
  Fade,
  Slide
} from "@mui/material";
import {
  Dashboard,
  People,
  PersonAdd,
  TableChart,
  Logout,
  Settings,
  Notifications,
  Menu as MenuIcon,
  Close
} from "@mui/icons-material";

// import Logo from "../assets/Images/Logo.png";
import { useNavigate, useLocation } from "react-router-dom";


const ResponsiveAppBar = ({ scrollToSection }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [user, setUser] = React.useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const userData = JSON.parse(storedUser)
    if (userData?.type === "admin" && userData?.status == 1) {
      setUser(userData);
    } else {
      navigate("/AdminLogin");
    }
  }, [navigate]);
 

  const handleUserMenuOpen = (event) => setAnchorElUser(event.currentTarget);
  const handleUserMenuClose = () => setAnchorElUser(null);
  const handleMobileMenuToggle = () => setMobileMenuOpen(!mobileMenuOpen);

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/AdminLogin");
  };

  const navigationItems = [
    { label: "Dashboard", icon: <Dashboard />, path: "/AdminDashbord" },
    { label: "Users", icon: <People />, path: "/admin/UsersTable" },
    { label: "Add Profile", icon: <PersonAdd />, path: "/admin/addProfile" },
    { label: "Profiles", icon: <TableChart />, path: "/admin/ProfileTable" },
  ];

  const isActivePath = (path) => location.pathname === path;

  return (
    <>
      <AppBar 
        position="fixed" 
        sx={{ 
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255,255,255,0.1)"
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: "space-between", py: 1 }}>
            {/* Logo Section */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography
                variant="h5"
                noWrap
                component="a"
                href="/AdminDashbord"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  transition: "transform 0.2s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)"
                  }
                }}
              >
                {/* <img
                  alt="logo"
                  src={Logo || "https://via.placeholder.com/100x50?text=Logo"}
                  style={{ 
                    height: "45px", 
                    objectFit: "contain",
                    filter: "brightness(0) invert(1)"
                  }}
                /> */}
              </Typography>
              
              {!isMobile && (
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: "white", 
                    fontWeight: "bold",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.3)"
                  }}
                >
                  Admin Panel
                </Typography>
              )}
            </Box>

            {/* Desktop Navigation */}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {navigationItems.map((item) => (
                  <Tooltip key={item.path} title={item.label}>
                    <Button
                      onClick={() => navigate(item.path)}
                      startIcon={item.icon}
                      sx={{
                        color: "white",
                        fontWeight: isActivePath(item.path) ? "bold" : "normal",
                        backgroundColor: isActivePath(item.path) 
                          ? "rgba(255,255,255,0.2)" 
                          : "transparent",
                        borderRadius: 2,
                        px: 2,
                        py: 1,
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.15)",
                          transform: "translateY(-2px)"
                        }
                      }}
                    >
                      {item.label}
                    </Button>
                  </Tooltip>
                ))}
              </Box>
            )}

            {/* User Section */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {/* Notifications */}
              {/* {!isMobile && (
                <Tooltip title="Notifications">
                  <IconButton sx={{ color: "white" }}>
                    <Badge badgeContent={3} color="error">
                      <Notifications />
                    </Badge>
                  </IconButton>
                </Tooltip>
              )} */}

              {/* User Profile */}
              {user && (
                <>
                  <Tooltip title="User Menu">
                    <Box
                      onClick={handleUserMenuOpen}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        p: 1,
                        borderRadius: 2,
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.1)",
                          transform: "scale(1.05)"
                        }
                      }}
                    >
                      <Avatar
                        sx={{
                          background: "linear-gradient(45deg, #4CAF50, #45a049)",
                          mr: 1,
                          width: 40,
                          height: 40,
                          border: "2px solid rgba(255,255,255,0.3)"
                        }}
                      >
                        {user.name ? user.name[0].toUpperCase() : "U"}
                      </Avatar>
                      <Box sx={{ display: { xs: "none", sm: "block" } }}>
                        <Typography 
                          sx={{ 
                            fontWeight: "bold", 
                            color: "white",
                            fontSize: "0.9rem"
                          }}
                        >
                          {user.name}
                        </Typography>
                        <Chip 
                          label="Admin" 
                          size="small" 
                          sx={{ 
                            backgroundColor: "rgba(255,255,255,0.2)",
                            color: "white",
                            fontSize: "0.7rem",
                            height: 20
                          }} 
                        />
                      </Box>
                    </Box>
                  </Tooltip>

                  <Menu
                    anchorEl={anchorElUser}
                    open={Boolean(anchorElUser)}
                    onClose={handleUserMenuClose}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        borderRadius: 2,
                        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                        border: "1px solid rgba(0,0,0,0.1)"
                      }
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem 
                      onClick={handleUserMenuClose}
                      sx={{ 
                        display: "flex", 
                        alignItems: "center", 
                        gap: 2,
                        py: 2,
                        px: 3
                      }}
                    >
                      <Avatar sx={{ 
                        background: "linear-gradient(45deg, #4CAF50, #45a049)",
                        width: 40,
                        height: 40
                      }}>
                        {user.name ? user.name[0].toUpperCase() : "U"}
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                          {user.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Administrator
                        </Typography>
                      </Box>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleUserMenuClose}>
                      <ListItemIcon>
                        <Settings fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Settings</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>
                      <ListItemIcon>
                        <Logout fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Logout</ListItemText>
                    </MenuItem>
                  </Menu>
                </>
              )}

              {/* Mobile Menu Button */}
              {isMobile && (
                <IconButton
                  onClick={handleMobileMenuToggle}
                  sx={{ color: "white" }}
                >
                  {mobileMenuOpen ? <Close /> : <MenuIcon />}
                </IconButton>
              )}
            </Box>
          </Toolbar>
        </Container>

        {/* Mobile Navigation Menu */}
        <Slide direction="down" in={mobileMenuOpen && isMobile} mountOnEnter unmountOnExit>
          <Box sx={{ 
            backgroundColor: "rgba(255,255,255,0.95)",
            backdropFilter: "blur(10px)",
            borderTop: "1px solid rgba(0,0,0,0.1)",
            p: 2
          }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {navigationItems.map((item) => (
                <Button
                  key={item.path}
                  onClick={() => {
                    navigate(item.path);
                    setMobileMenuOpen(false);
                  }}
                  startIcon={item.icon}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    color: isActivePath(item.path) ? "#667eea" : "#333",
                    backgroundColor: isActivePath(item.path) 
                      ? "rgba(102, 126, 234, 0.1)" 
                      : "transparent",
                    borderRadius: 2,
                    py: 1.5,
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      backgroundColor: "rgba(102, 126, 234, 0.1)"
                    }
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
          </Box>
        </Slide>
      </AppBar>
      <Toolbar />
    </>
  );
};

export default ResponsiveAppBar;
